import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ClientEntity } from './client.entity';

@Index('fk_client__id', ['fkClientId'], {})
@Entity('client_inquiry')
export class ClientInquiryEntity extends BaseEntity {
	@Column('int', { name: 'fk_client__id', unsigned: true })
	public fkClientId!: number;

	@Column('varchar', { name: 'type', length: 64 })
	public type!: string;

	@Column('varchar', { name: 'status', length: 64 })
	public status!: string;

	@Column('text', { name: 'message' })
	public message!: string;

	@ManyToOne(() => ClientEntity, (client) => client.clientInquiries, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: 'fk_client__id', referencedColumnName: 'id' }])
	public fkClient!: ClientEntity;
}
